import React, { createContext, useContext, useState } from 'react';
import { ResetMapState } from '../js/Main';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [depname, setDepName] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const login = (userData) => {
    // Дополнительная логика, если необходимо, например, сохранение в localStorage.
    setUser(userData.login);
    setUserId(userData.user_id);
    setDepName(userData.depname);
    setPermissions(userData.permissions);
    console.log("userData = " + userData.permissions);
  };

  const logout = () => {
    // Дополнительная логика, если необходимо, например, удаление из localStorage.
    setUser(null);
    setUserId(null);
    setDepName(null);
    setPermissions([]);

    ResetMapState();
  };

  return (
    <AuthContext.Provider value={{ user, userId, depname, permissions, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};